// JointHolder/AddressVerification/index.js
import InputTitle from "designs/v1/components/InputTitle";
import Title from "designs/v1/components/Title";
import React, { useEffect, useRef, useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import { useDispatch, useSelector } from "react-redux";
import { validateIncomeProof } from "../../IncomeProof/redux/action";
import { toast } from "react-toastify";
import { makeid, getApiHeader, getApiUrl } from "utils";
import { getStageScreen, setLoading } from "../../../../../redux";
import Button from "../../../components/Button";
import axios from "axios";

const FILE_TYPES = ["JPG", "JPEG", "PNG", "PDF"];

function CorrespondanceAddress({ activeHolder }) {
  const dispatch = useDispatch();
  let stages = useSelector((state) => state.navigation.stagesData);
  const { inputLabelColor, inputError } = useSelector((state) => state.theme);
  const [addressProofType, setAddressProofType] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [addressFrontImage, setAddressFrontImage] = useState();
  const [addressBackImage, setAddressBackImage] = useState();
  const [checkType, setCheckType] = useState(true);
  const [isDisable1, setIsDisable1] = useState(false);
  const [isDisable2, setIsDisable2] = useState(false);
  const addressFrontImageRef = useRef();
  const addressBackImageRef = useRef();

  const [showPanUpload, setShowPanUpload] = useState(true);

  useEffect(() => {
    if (activeHolder == 2) {
      const activeDetails = stages.secound_holder?.pan?.status;
      if (activeDetails) {
        setShowPanUpload(false);
      }
    }
    if (activeHolder == 3) {
      const activeDetails = stages.thrid_holder?.pan?.status;
      if (activeDetails) {
        setShowPanUpload(false);
      }
    }
  }, [stages]);

  //   const getApiUrl = () => {
  //     const portal_domain = window.sessionStorage.getItem("portal_domain");
  //     let API_URL = "";
  //     if (portal_domain) {
  //       API_URL = portal_domain.substring(0, portal_domain.length - 1);
  //     }
  //     return API_URL;
  //   };

  const handleAddressType = (event) => {
    setAddressProofType(event.target.value ?? "");
    setAddressFrontImage("");
    setAddressBackImage("");
    if (addressFrontImageRef.current) {
      addressFrontImageRef.current.value = "";
    }
    if (addressBackImageRef.current) {
      addressBackImageRef.current.value = "";
    }
  };

  const token = window.sessionStorage.getItem("token");
  const uploadAddressFrontImg = async (thefile) => {
    if (thefile) {
      const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
      if (!allowed_types.includes(thefile.type)) {
        toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
        return;
      }
      const fileSize = thefile.size / 1024 ** 2;
      if (fileSize >= 4) {
        toast.error("Please upload a file smaller than 4MB");
        return;
      }
      if (thefile.type === "application/pdf") {
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", thefile, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
          dispatch(setLoading(false));
        } catch (error) {}
        if (isEncrypted) {
          toast.error("Please upload a file without password.");
          dispatch(setLoading(false));
          return;
        }
        setAddressFrontImage(thefile);
        setCheckType(true);
        setIsDisable2(true);
      } else {
        let img = new Image();
        img.src = window.URL.createObjectURL(thefile);
        img.onload = async () => {
          if (img.width >= 250 && img.height >= 200) {
            setAddressFrontImage(thefile);
            setCheckType(true);
            setIsDisable2(true);
          } else {
            return toast.error(
              `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
            );
          }
        };
      }
    }
  };
  const uploadAddressBackImg = async (thefile) => {
    if (thefile) {
      const allowed_types = ["image/png", "image/jpeg", "application/pdf"];
      if (!allowed_types.includes(thefile.type)) {
        toast.error("Only Images are allowed ( JPG | PNG | PDF )", "Error");
        return;
      }
      const fileSize = thefile.size / 1024 ** 2;
      if (fileSize >= 4) {
        toast.error("Please upload a file smaller than 4MB");
        return;
      }
      if (thefile.type === "application/pdf") {
        let isEncrypted = false;
        dispatch(setLoading(true));
        try {
          const formData = new FormData();
          formData.append("file", thefile, makeid(6) + ".pdf");
          const resp = await validateIncomeProof(formData);
          isEncrypted = resp.data?.message || false;
          dispatch(setLoading(false));
        } catch (error) {}
        if (isEncrypted) {
          toast.error("Please upload a file without password.");
          dispatch(setLoading(false));
          return;
        }
        setAddressBackImage(thefile);
        setCheckType(true);
        setIsDisable2(true);
      } else {
        let img = new Image();
        img.src = window.URL.createObjectURL(thefile);
        img.onload = async () => {
          if (img.width >= 250 && img.height >= 200) {
            setAddressBackImage(thefile);
            setCheckType(true);
            setIsDisable2(true);
          } else {
            return toast.error(
              `The image you uploaded is of lower resolution. Please upload a higher resolution image.`
            );
          }
        };
      }
    }
  };
  const uploadPanImage = async (file) => {
    if (!file) return;

    // Allowed file types and size limit
    const allowedTypes = ["image/png", "image/jpeg", "application/pdf"];
    const maxSizeMB = 4;

    // Check if file type is allowed
    if (!allowedTypes.includes(file.type)) {
      toast.error("Only JPG, PNG, and PDF files are allowed.");
      return;
    }

    // Check file size
    const fileSizeMB = file.size / 1024 ** 2;
    if (fileSizeMB > maxSizeMB) {
      toast.error(`Please upload a file smaller than ${maxSizeMB}MB.`);
      return;
    }

    // Append file to FormData
    const formData = new FormData();
    formData.append("files", file);
    formData.append("holder", activeHolder);
    formData.append(
      "file_type",
      file.type === "application/pdf" ? "pdf" : "Image"
    );

    // API URL - Adjust according to your API's requirements
    const apiUrl = `${getApiUrl()}/api/method/kyc_customizations.apis.joint_holder.poi_upload.endpoint`;

    try {
      dispatch(setLoading(true));

      // Perform the API request
      const response = await fetch(apiUrl, {
        method: "POST",
        body: formData,
        headers: { Authorization: `Basic ${token}` },
      });

      const data = await response.json();
      dispatch(setLoading(false));
      dispatch(getStageScreen());

      if (response.ok) {
        toast.success("PAN uploaded successfully!");
        // Additional success handling
      } else {
        throw new Error(data.message || "Failed to upload PAN image.");
      }
    } catch (error) {
      dispatch(setLoading(false));
      toast.error(error.message || "An error occurred during the upload.");
    }
  };

  const submitAddressProof = async () => {
    if (!addressFrontImage || !addressProofType) {
      toast.error("Please fill in all required fields.");
      return;
    }

    const formData = new FormData();
    formData.append("file1", addressFrontImage);
    formData.append("type", addressProofType);
    if (addressBackImage) {
      formData.append("file2", addressBackImage);
    }
    formData.append("holder", activeHolder.toString());
    formData.append(
      "file_type",
      addressFrontImage.type === "application/pdf" ? "pdf" : "Image"
    );
    dispatch(setLoading(true));
    try {
      await axios.post(
        `${getApiUrl()}/api/method/kyc_customizations.apis.joint_holder.corspondance_poa.endpoint`,
        formData,
        getApiHeader()
      );
      dispatch(setLoading(false));
      dispatch(getStageScreen());
      toast.success("Documents uploaded successfully!");
    } catch (error) {
      dispatch(setLoading(false));
      const response = error.response;
      toast.error(response?.message || "Internal server error!");
    }
    // try {
    //   dispatch(setLoading(true));
    //   const apiUrl = `${getApiUrl()}/api/method/kyc_customizations.apis.joint_holder.poa_upload.endpoint`;
    //   const response = await fetch(apiUrl, {
    //     method: "POST",
    //     body: formData,
    //     // Add headers if your API requires them. Omit credentials if not needed.
    //     headers: { Authorization: `Basic ${token}` },
    //     credentials: "include",
    //   });
    //   const data = await response.json();

    //   dispatch(setLoading(false));
    //   dispatch(getStageScreen());
    //   if (response.ok) {
    //     toast.success("Documents uploaded successfully!");
    //     // Handle success logic, maybe clearing the form or redirecting the user
    //   } else {
    //     throw new Error(data.message || "Failed to upload documents");
    //   }
    // } catch (error) {
    //   dispatch(setLoading(false));
    //   toast.error(error.message || "An error occurred");
    // }
  };

  return (
    <div className="row">
      <div className="col-12 col-md-12 mb-4">
        <Title title="Correspondence Address Document Upload" />
        <div className="col-md-6 col-12">
          <>
            <div className="mt-2">
              <InputTitle
                className="mb-1"
                title={"Upload your address proof"}
              />
              <select
                onChange={handleAddressType}
                className={
                  "form-select" +
                  (submitted && !addressProofType ? " is-invalid" : "")
                }
              >
                <option value="">--Select--</option>
                <option value="Aadhaar">Aadhaar</option>
                <option value="Passport">Passport</option>
                {getApiUrl() != "https://scmcbrke.in" && (
                  <>
                    <option value="DrivingLicense">Driving Licence</option>
                    <option value="VoterID">Voter Id</option>
                  </>
                )}
              </select>
              {submitted && !addressProofType && (
                <div style={{ color: inputError }}>Please select an option</div>
              )}
            </div>
            {addressProofType && (
              <>
                <div className="row d-flex align-items-center mt-2">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-12">
                        <InputTitle
                          title={`Front Image (jpg, png, pdf)`}
                          isRequired={true}
                          className={"my-1"}
                        />
                      </div>
                    </div>
                    <div className="file-uploader-container">
                      <FileUploader
                        handleChange={(file) => uploadAddressFrontImg(file)}
                        name="file"
                        types={FILE_TYPES}
                        disabled={isDisable1}
                        ref={addressFrontImageRef}
                      />
                      {addressFrontImage?.name && (
                        <p>
                          <small>File name: {addressFrontImage.name}</small>
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="row d-flex align-items-center mt-2">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-12">
                        <InputTitle
                          title={`Back Image (jpg, png, pdf)`}
                          isRequired={addressProofType !== "DrivingLicense"}
                          className={"my-1"}
                        />
                      </div>
                    </div>
                    <div className="file-uploader-container">
                      <FileUploader
                        handleChange={(file) => uploadAddressBackImg(file)}
                        name="file"
                        types={FILE_TYPES}
                        disabled={isDisable1}
                        ref={addressBackImageRef}
                      />
                      {addressBackImage?.name && (
                        <p>
                          <small>File name: {addressBackImage.name}</small>
                        </p>
                      )}
                    </div>
                  </div>
                </div>
                <div>
                  <label className="my-1 text-muted text-sm">
                    <small>{"Maximum file size: 4 MB"}</small>
                  </label>
                </div>
              </>
            )}
            <div className="mt-3"></div>
            <Button
              className="btn btn-primary"
              handleClick={submitAddressProof}
              title="Submit"
            >
              Submit
            </Button>
          </>
        </div>
      </div>
    </div>
  );
}

export default CorrespondanceAddress;
